/* tslint:disable */
/* eslint-disable */
/**
 * Brandside Backend API
 * REST API бэкенда Brandside. Авторизация — Bearer-токен Laravel Passport (заголовок Authorization: Bearer token). Успешные ответы оборачиваются в конверт success_response — status: true, data: ...; ошибки — common_error_response — status: false, errors._common: сообщение.
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime'
/**
 *
 * @export
 * @interface RegistryApplicationCounts
 */
export interface RegistryApplicationCounts {
  /**
   *
   * @type {number}
   * @memberof RegistryApplicationCounts
   */
  applications: number
  /**
   *
   * @type {number}
   * @memberof RegistryApplicationCounts
   */
  ips: number
}

/**
 * Check if a given object implements the RegistryApplicationCounts interface.
 */
export function instanceOfRegistryApplicationCounts(
  value: object
): value is RegistryApplicationCounts {
  if (!('applications' in value) || value['applications'] === undefined)
    return false
  if (!('ips' in value) || value['ips'] === undefined) return false
  return true
}

export function RegistryApplicationCountsFromJSON(
  json: any
): RegistryApplicationCounts {
  return RegistryApplicationCountsFromJSONTyped(json, false)
}

export function RegistryApplicationCountsFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): RegistryApplicationCounts {
  if (json == null) {
    return json
  }
  return {
    applications: json['applications'],
    ips: json['ips'],
  }
}

export function RegistryApplicationCountsToJSON(
  value?: RegistryApplicationCounts | null
): any {
  if (value == null) {
    return value
  }
  return {
    applications: value['applications'],
    ips: value['ips'],
  }
}
